import(/* webpackMode: "eager" */ "/app/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/analytics/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantBillingAccessGate"] */ "/app/apps/web/src/components/auth/tenant-billing-access-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackendStatusBanner"] */ "/app/apps/web/src/components/ui/backend-status-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantBillingAccessBanner"] */ "/app/apps/web/src/components/ui/tenant-billing-access-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/apps/web/src/components/ui/toast-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/apps/web/src/hooks/useToast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/apps/web/src/providers/session-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TenantProvider"] */ "/app/apps/web/src/providers/tenant-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
